import React, { useState } from "react";
import { LikertInputCircles } from "./SurveyLikertInput";

export default function SurveyLikertQuestion({ item, value, onChange, disableClicks, setDisableClicks }) {
  const [pending, setPending] = useState(null);
  if (!item) return null;

  const rawLevels = typeof item.levels === "number" ? item.levels : undefined;
  const levels = rawLevels && rawLevels > 0 ? rawLevels : 5;

  const handleClick = (levelValue) => {
    if (disableClicks) return;
    setDisableClicks(true);
    setPending(levelValue);
    setTimeout(() => {
      setPending(null);
      onChange(levelValue);
    }, 200);
    setTimeout(() => {
      setDisableClicks(false);
    }, 200);
  };

  return (
    <div className="flex flex-col items-center gap-2 w-full">
      <div className="flex items-center gap-5">
        <span className="text-md text-slate-500 whitespace-nowrap mr-1">Strongly disagree</span>
        <LikertInputCircles
          levels={levels}
          value={value}
          pending={pending}
          disableClicks={disableClicks}
          handleClick={handleClick}
        />
        <span className="text-md text-slate-500 whitespace-nowrap ml-1">Strongly agree</span>
      </div>
    </div>
  );
}
